var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon_valid)?_c('div',{staticClass:"triumph-icon",style:(_vm.offset_style),attrs:{"title":_vm.icon.name}}):_c('div',{staticClass:"triumph-icon"})}
var staticRenderFns = []

export { render, staticRenderFns }